import { z } from 'zod';

export const UpdateCustomerVehicleBodySchema = z.object({
  vehicleModelId: z.uuid(),
  /** Accepted only while `customer_vehicles.registration_status` is `DRAFT` (validated in use case). */
  plate: z.string().trim().nullable().optional(),
  /** Accepted only while `customer_vehicles.registration_status` is `DRAFT` (validated in use case). */
  chassis: z.string().trim().nullable().optional(),
  color: z.string().trim().nullable().optional(),
  manufactureYear: z.number().int().min(1900).max(2100).nullable().optional(),
  modelYear: z.number().int().min(1900).max(2100).nullable().optional(),
  fipeCode: z.string().trim().nullable().optional(),
  vehicleGenerationId: z.uuid().nullable().optional(),
  vehicleTrimId: z.uuid().nullable().optional(),
  vehicleEngineId: z.uuid().nullable().optional(),
  engineNumber: z.string().trim().nullable().optional(),
  engineNumberSource: z.enum(['LOOKUP', 'MANUAL']).nullable().optional(),
  nickname: z.string().trim().nullable().optional(),
  notes: z.string().trim().nullable().optional(),
  acquiredAt: z.iso.date().nullable().optional(),
});

export type UpdateCustomerVehicleBody = z.infer<typeof UpdateCustomerVehicleBodySchema>;

export const UpdateCustomerVehicleResponseSchema = z.object({
  customerVehicleId: z.uuid(),
  changedFields: z.array(z.string()),
});

export type UpdateCustomerVehicleResponse = z.infer<typeof UpdateCustomerVehicleResponseSchema>;
